import { fetchWithAuth } from "@/lib/api";
import { ImportResult } from "@/schemas";
import { API_BASE } from "@/config/api";

export async function getSupportedBrokers(): Promise<string[]> {
    const response = await fetchWithAuth(`${API_BASE}/import/supported-brokers`);
    if (!response.ok) {
        throw new Error("Failed to get supported brokers");
    }
    const data = await response.json();
    return data.supported_brokers;
}

export async function importTransactions(broker: string, bookId: string, file: File): Promise<ImportResult> {
    const formData = new FormData();
    formData.append('file', file);

    const url = `${API_BASE}/import/transactions?broker=${encodeURIComponent(broker)}&bookId=${encodeURIComponent(bookId)}`;

    const response = await fetchWithAuth(url, {
        method: 'POST',
        body: formData,
    });

    let data: unknown = null;
    try {
        data = await response.json();
    } catch {
        if (!response.ok) {
            throw new Error("Failed to import transactions");
        }
        throw new Error("Failed to parse import response");
    }

    const parsedData = data as Partial<ImportResult> & { error?: string; message?: string };

    if (!response.ok) {
        if (parsedData && typeof parsedData === "object" && "transactions_imported" in parsedData) {
            return {
                ...parsedData,
                missing_assets: parsedData.missing_assets || [],
                skipped_transactions: parsedData.skipped_transactions || [],
                errors: parsedData.errors || [],
            } as ImportResult;
        }
        const errorMessage = parsedData?.error || parsedData?.message || "Failed to import transactions";
        return {
            message: "Import failed",
            transactions_imported: 0,
            transactions_skipped: 0,
            missing_assets: [],
            skipped_transactions: [],
            errors: [{ row_number: 0, message: errorMessage }],
        } as ImportResult;
    }

    // Normalize response to ensure arrays are never null
    return {
        ...parsedData,
        missing_assets: parsedData.missing_assets || [],
        skipped_transactions: parsedData.skipped_transactions || [],
        errors: parsedData.errors || [],
    } as ImportResult;
}
